export interface LoginParams {
  username: string;
  password: string;
}

const evDebug = false;

export function evLog(...args: any[]): void {
  if (!evDebug) return;
  console.log(...args);
}
